<button class="btn btn-info btn-block" [disabled]="!isEnabled || isLocked || isLocked" (click)="openPauseModal()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-pause" #icon></i>
    <span class="element-text">{{ 'console.pause' | translate }}</span>
</button>
